export type CampaignPortalModel = {
  cache_key: number,
  id: number,
  campaign_id: number,
  enabled_portal_option_values?: number[],
  last_sync_failed: boolean,
  outgoing_agent_id?: number,
  portal_id: number,
}

export type CampaignPortalRequestOptions = {}

const state = {
  id: null,
  enabled_portal_option_values: [],
  outgoing_agent_id: null,
}

export const requiredFields = []

export default state
